import { CREATE_USER_SUCCESS, CREATE_USER_FAILURE, 
    LOGIN_USER_SUCCESS, LOGIN_USER_FAILURE,
    RECOVERY_USER_SUCCESS, RECOVERY_USER_FAILURE, RESET_STORE } from "../actions/userActions";
import rootReducers from "./rootReducers";

const initialState={
    loading: true,
    data: [],
    error : ""
}

const user = (state=initialState, action)=> { 
    switch(action.type){
        case CREATE_USER_SUCCESS:
            return {
                loading:false,
                data: action.payload,
                error:null
            }
        case CREATE_USER_FAILURE: 
            return{
                loading:false,
                data: [],
                error: action.payload
            }
        case LOGIN_USER_SUCCESS:
            return {
                loading:false,
                data: action.payload,
                error:null
            }
        case LOGIN_USER_FAILURE: 
            return{
                loading:false,
                data: [],
                error: action.payload
            }
        case RECOVERY_USER_SUCCESS:
            return {
                loading:false,
                data: action.payload,
                error:null
            }
        case RECOVERY_USER_FAILURE: 
            return{
                loading:false,
                data: [],
                error: action.payload
            }
        case RESET_STORE:
            return{
                loading:false,
                data: [],
                error: null
            }
        default: return state;
    }
}

export default user;